import WeatherHourStrip from './WeatherHourStrip';
import { hoursForDay, type Hour } from '../lib/weather';
import type { WeddingEvent } from '../lib/content';

/**
 * The hourly forecast across one day of the programme, on a phone (D67).
 *
 * **Phone only.** Above 900px the Schedule's rail carries `WeatherRail`, which
 * says the same thing with room to spell the conditions out; a strip here as
 * well would be the same forecast twice.
 *
 * **Scoped to the day's events, not to the day.** `hoursForDay` takes the span
 * from an hour before the first thing to an hour after the last, which on the
 * 6th is 10:00 to a little past midnight and on the 8th is four cells. A
 * midnight-to-midnight strip would be twenty-four columns, most of them
 * asleep, and the hours a guest cares about would be scrolled off the end.
 *
 * **Nothing renders when there are no hours**, which is the common case until
 * late October: Open-Meteo forecasts sixteen days, so the week only enters the
 * window around the 21st and the strips fill in from the top of the week down.
 * An empty row of placeholder cells under every heading would be four days of
 * the Schedule looking broken, so the component removes itself instead.
 *
 * The cells themselves are `WeatherHourStrip`, shared with the pill's panel on
 * Now so the two cannot drift apart.
 */
export default function WeatherHours(
  { hours, events, dayKey: key }: { hours: Hour[]; events: WeddingEvent[]; dayKey: string },
) {
  const cells = hoursForDay(hours, events, key);
  if (cells.length === 0) return null;

  return (
    <div className="wx-hours">
      <WeatherHourStrip hours={cells} label="Hourly forecast" />
    </div>
  );
}
